<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="con">
      <div class="con-inner">
        <div class="con-search">
          <SearchBarCircle
            :num="totalItem"
            v-model="searchKey"
            @btnClick="searchBarClick"
            placeholder="请输入关键字"
          />
        </div>
        <div class="con-lists">
          <div v-for="(item, index) in lists" :key="index" class="qa">
            <div class="qa-title">
              <img :src="$oss('helpCenter/icon-qa.png')" class="qa-icon" />
              <span>{{ item.problemDesc }}</span>
            </div>
            <div>{{ item.solution }}</div>
          </div>
        </div>
        <!-- 分页-->
        <Pagination
          :total="totalItem"
          :page="page"
          @pageIndexChange="handlePageChange"
        />
      </div>
    </div>
    <FootBar />
  </div>
</template>
<script>
import SearchBarCircle from "@/components/SearchBarCircle/index";
import Pagination from "@/components/Pagination/index";
import { helpLists } from "@/api/helpCenter";
export default {
  components: {
    SearchBarCircle,
    Pagination,
  },
  data() {
    return {
      totalItem: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      searchKey: "",
      lists: [],
    };
  },
  created() {
    this.queryList();
  },
  methods: {
    searchBarClick() {
      this.page.pageIndex = 1;
      this.queryList();
    },
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.queryList();
    },
    async queryList() {
      const { list, totalItem } = await this.$axios.post(helpLists, {
        ...this.page,
        problemDesc: this.searchKey,
      });
      this.lists = list;
      this.totalItem = totalItem;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.qa {
  background: white;
  padding: 16px;
  // margin-bottom: 15px;
  &-icon {
    width: 32px;
    height: 25px;
    margin-right: 10px;
  }
  &-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 12px;
  }
}
.con {
  background: $home-bg;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    min-height: 500px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  &-search {
    background: white;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  &-lists {
    // min-height: 500px;
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: repeat(2, 592px);
    gap: 16px;
  }
}
</style>
